import React from "react";

import { TabType, DESKTOP, OPENING_HOURS, HANDICAPED, COMPANIES, SERVICES } from "@constants";
import { lowerCaseFirstLetter } from "@utilities";

import { FiltersProps, IconsListProps } from "../../../types";

import FormControl from "../FormControl";
import FilterCheckbox from "../FilterCheckbox";
import FiltersDesktopToggleAndDropdown from "./FiltersDesktopToggleAndDropdown";

/* eslint-disable jsx-a11y/label-has-associated-control */

type FiltersDesktopFormBranchesProps = {
  type: TabType;
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & FiltersProps &
  IconsListProps;

const FiltersDesktopFormBranches: React.FC<FiltersDesktopFormBranchesProps> = ({
  filters,
  iconsList,
  type,
  handleOnChange,
}) => {
  // icons
  const { arrowDown } = iconsList;

  // solo checkboxes
  const filtersCheckboxes = filters.slice(0, 1);

  // dropdown checkboxes
  const filtersOpeningHours = filters[1].items;
  const filtersHandicaped = filters[2].items;
  const filtersCompanies = filters[3].items;
  const filtersServices = filters[4].items;

  // texts
  const toggleOpeningHoursText = filters[1].name;
  const toggleHandicapedText = filters[2].name;
  const toggleCompaniesText = filters[3].name;
  const toggleServicesText = filters[4].name;

  return (
    <form className={`form-filters-${DESKTOP}-${type} mb-8 flex flex-row`}>
      {filtersCheckboxes.map((item) => {
        const itemValue = lowerCaseFirstLetter(item.value);

        return (
          <FormControl key={itemValue}>
            <FilterCheckbox
              type={type}
              id={`${DESKTOP}-${itemValue}`}
              name={itemValue}
              checkboxValue={itemValue}
              defaultChecked={item.isChecked}
              label={item.name}
              handleOnChange={handleOnChange}
            />
          </FormControl>
        );
      })}

      <FiltersDesktopToggleAndDropdown
        iconsList={arrowDown}
        type={type}
        name={OPENING_HOURS}
        viewport={DESKTOP}
        text={toggleOpeningHoursText}
        filters={filtersOpeningHours}
        handleOnChange={handleOnChange}
      />

      <FiltersDesktopToggleAndDropdown
        iconsList={arrowDown}
        type={type}
        name={HANDICAPED}
        viewport={DESKTOP}
        text={toggleHandicapedText}
        filters={filtersHandicaped}
        handleOnChange={handleOnChange}
      />

      <FiltersDesktopToggleAndDropdown
        iconsList={arrowDown}
        type={type}
        name={COMPANIES}
        viewport={DESKTOP}
        text={toggleCompaniesText}
        filters={filtersCompanies}
        handleOnChange={handleOnChange}
      />

      <FiltersDesktopToggleAndDropdown
        iconsList={arrowDown}
        type={type}
        name={SERVICES}
        viewport={DESKTOP}
        text={toggleServicesText}
        filters={filtersServices}
        handleOnChange={handleOnChange}
      />
    </form>
  );
};

export default FiltersDesktopFormBranches;
